import { IProgramServiceState } from '../../../types'

const initProgramServiceState: IProgramServiceState = {
  isFetching: false,
  items: {
    61: {
      id: 61,
      name: 'PSTA DART',
      organization_id: 1,
      providers: ['1', '2', '3', '4', '5']
    },
    62: {
      id: 62,
      name: 'PSTA TD LATE SHIFT',
      organization_id: 1,
      providers: ['1', '2']
    }
  },
  lastUpdated: Date.now()
}

export function programService(state: IProgramServiceState): IProgramServiceState {
  if (typeof state === 'undefined') {
    return initProgramServiceState
  }

  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/program_services/index.ts